const carCleaningDetailedRateCard = {
  key: "car-cleaning",
  title: "Car Cleaning Detailed Rate Card",
  note:
    "Indicative car cleaning pricing. Final price depends on vehicle size, dirt level, stain level, and whether recurring service is selected.",
  sections: [
    {
      title: "Basic Cleaning",
      items: [
        { name: "Basic exterior cleaning", price: "₹299 per car" },
        { name: "Basic interior cleaning", price: "₹399 onwards" },
        { name: "Full car cleaning", price: "₹599 onwards" },
      ],
    },
    {
      title: "Recurring Plans",
      items: [
        { name: "Monthly car cleaning plan", price: "₹1499 onwards" },
      ],
    },
  ],
};

export default carCleaningDetailedRateCard;